import React from 'react';
export function useNotify(state, props) {
    var emitChange = state.emitChange, getRef = state.getRef;
    var delayed = props.delayed, noDelayed = props.noDelayed;
    var notifier = React.useRef(null);
    function notify(value, event) {
        if (noDelayed || delayed === false) {
            emit(value, event);
        }
        else {
            if (notifier.current)
                clearTimeout(notifier.current);
            notifier.current = setTimeout(function () {
                emit(value, event);
            }, typeof delayed === 'number' ? delayed : 200);
        }
    }
    function emit(value, event) {
        event.target = getRef().current;
        event.target.value = value;
        emitChange(value, event);
    }
    function change(event) {
        notify(event.target['value'], event);
    }
    return {
        emit: emit,
        notify: notify,
        onChange: change
    };
}
